import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Select from 'react-select'
import FilterPagination from 'pages/parts/FilterPagination'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

import { GET, httpOk } from 'helpers/api'
import { checkFilter, chequeDates, formatDate, formatMoney, getCurrentChequeDate } from 'helpers/helpers'

function Sales() {
	const { t } = useTranslation()

	const date = new Date()
	const initialFilter = {
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		pos_id: null,
		search: ''
	};

	const [data, setData] = useState([])
	const [showModal, setShowModal] = useState({ show: false, data: {} })

	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({ ...initialFilter })
	const [pagination, setPagination] = useState({
		url: `/shifts/`,
		response: null
	})

	async function toggleModal(bool, item, product_type) {
		if (bool) {
			const response = await GET('/report/cashiers/history', { ...filterData, cashier_login: item.login, product_type: product_type }, { loader: true })
			if (httpOk(response)) {
				setShowModal({ show: true, data: response.data })
				setPagination({ ...pagination, 'response': response.data })
			}

		} else {
			setShowModal({ ...showModal, show: false })
		}
	}

	function resetFilter() {
		setFilterData({ ...initialFilter })
	}

	async function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result, 'dateType': option.id })
	}

	async function getData() {
		setFilterDataExist(checkFilter(filterData, initialFilter));

		const response = await GET("/report/cashiers", filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'response': response.data })
			if (dropdownIsOpen) setDropdownIsOpen(false)
		}
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}


	useEffect(() => {
		getData()
	}, [filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('cashiers')} [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<Select
													options={chequeDates}
													value={chequeDates.find(option => option.id === filterData.dateType) || ''}
													onChange={(option) => selectChequeDates(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-4">
												<label className="invisible">{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>

										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => getData()}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }}>#</th>
									<th style={{ 'width': '15%' }}>{t('login')}</th>
									<th style={{ 'width': '15%' }}>{t('name2')}</th>
									<th style={{ 'minWidth': '100px' }} className="text-end">{t('cheques')}</th>
									<th style={{ 'minWidth': '100px' }} className="text-end">{t('products')}</th>
									<th style={{ 'minWidth': '100px' }} className="text-end">{t('accessory')}</th>
									<th style={{ 'minWidth': '100px' }} className="text-end">{t('profiled_sheeting')}</th>
									<th style={{ 'minWidth': '100px' }} className="text-end">{t('tunikofon')}</th>
									{/* <th style={{ 'minWidth': '100px' }} className="text-end">{t('total')}</th> */}
									<th style={{ 'width': '8%' }} className="text-end">{t('expenses')}</th>
									<th style={{ 'width': '8%' }} className="text-end">{t('discount_amount')}</th>
									<th style={{ 'width': '8%' }} className="text-end">{t('sale_amount')}</th>

								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index} className="bg-on-hover">
										<td>{item.row_number}</td>
										<td>{item.login}</td>
										<td className="td-ellipsis">{item.name}</td>
										<td className="text-end">{formatMoney(item.total_cheques, 2)}</td>
										<td className="text-end" onClick={() => toggleModal(true, item, 1)}>{formatMoney(item.products_type_1, 2)}</td>
										<td className="text-end" onClick={() => toggleModal(true, item, 3)}>{formatMoney(item.products_type_3, 2)}</td>
										<td className="text-end" onClick={() => toggleModal(true, item, 4)}>{formatMoney(item.products_type_4, 2)}</td>
										<td className="text-end" onClick={() => toggleModal(true, item, 5)}>{formatMoney(item.products_type_5, 2)}</td>
										{/* <td className="text-end" onClick={() => toggleModal(true, item)}>{formatMoney(item.total_products, 2)}</td> */}
										<td className="text-end">{formatMoney(item.total_expenses, 2)}</td>
										<td className="text-end">{formatMoney(item.total_discount, 2)}</td>
										<td className="text-end">{formatMoney(item.total_amount, 2)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<Modal show={showModal.show} animation={false} centered dialogClassName="update-modal-width"
				onHide={() => toggleModal(false)} size="xl">
				<Modal.Header closeButton>
					<Modal.Title>
						{showModal.data.cashier_login} [{formatMoney(showModal.data.total_metr_sold)}]
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>


					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '5%' }} className="text-start">{t('cheque')} ID</th>
									<th style={{ 'width': '30%' }}>{t('product_name')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('date')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('size')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('metr')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('price')}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{showModal?.data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="text-start">{item.cheque_id}</td>
										<td>{item.name}</td>
										<td className="text-center">{formatDate(item.cheque_closed_at)}</td>
										<td className="text-end">{formatMoney(item.quantity, 2)}</td>
										<td className="text-end">{formatMoney(item.element_quantity, 2)}</td>
										<td className="text-end">{formatMoney(item.metr, 2)}</td>
										<td className="text-end">{formatMoney(item.sale_price)}</td>
										<td className="text-end">{formatMoney(item.total_price)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Sales